"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.visuallyHidden = exports.hiddenCss = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var hiddenCss = "\n  position: absolute !important;\n  clip: rect(1px,1px,1px,1px) !important;\n  height: 1px !important;\n  width: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  margin: 0 !important;\n"; // This lets you wrap an existing styled component
// `const HiddenThing = visuallyHidden(Thing);`

exports.hiddenCss = hiddenCss;

var visuallyHidden = function visuallyHidden(component) {
  return (0, _styledComponents.default)(component)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  ", ";\n"], ["\n  ", ";\n"])), hiddenCss);
};

exports.visuallyHidden = visuallyHidden;

var VisuallyHidden = _styledComponents.default.span(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  ", ";\n"], ["\n  ", ";\n"])), hiddenCss);

var _default = VisuallyHidden;
exports.default = _default;
var templateObject_1, templateObject_2;